export default {
  // Units
  unit: '个',

  biz: '企业端',
  agent: '猎头端',
  logout: '退出登录',
  language: '语言',
  collapse: '收起',
  welcome: '欢迎',
  download: '下载',
  delete: '删除',
  upload: '上传',
  submit: '提交',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  confirm1: '确认',
  ok: '好的',
  yes: '好的',
  edit: '编辑',
  save: '保存',
  reset: '重置',
  search: '搜索',
  view: '查看',
  detail: '详情',
  success: '成功',
  failed: '失败',
  dataGetFailed: '获取数据失败',
  loading: '加载中...',
  uploading: '上传中...',
  downloading: '下载中...',
  downloadStarted: '开始下载',
  downloadFailed: '下载失败',
  actions: '操作',
  downloadSuccess: '下载成功',
  deleteSuccess: '删除成功',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败',
  chooseFile: '选择文件',
  chooseFileFromCompany: '请从企业常用资料中选择需要的文件',
  addFile: '添加文件',
  manageFiles: '管理资料',
  emptyFileMessage: '尚未添加，请先管理企业常用资料',
  fileName: '文件名称',
  uploadTime: '上传时间',
  fileSize: '文件大小',
  prev: '上一步',
  next: '下一步',
  saveAndOut: '保存并退出',
  tableStats: '共计: #total# 条',
  fileFormatNotSupported: '文件格式不支持，请上传 {0} 格式的文件',
  filePreviewNotSupported: '文件格式不支持预览，请下载后查看',
  fileSizeExceeded: '文件大小不能超过 {0} MB',
  maxUploadCountExceeded: '最多支持上传 {0} 个文件',
  confirmLeave: {
    title: '确认离开',
    content: '修改尚未保存，确定要离开吗？',
  },
  confirmDeleteEmployee: {
    title: '删除候选人',
    content: '删除后不可恢复，确定删除候选人「{0}」吗？',
  },
  cannotDeleteEmployee: {
    title: '暂不支持删除候选人',
    content: '候选人「{0}」下有进行中的选考，暂不支持删除。',
    confirm: '好的',
  },
  confirmDeleteFile: {
    title: '确认删除文件',
    content: '删除后不可恢复，确定删除文件「{0}」吗？',
  },
  deleteConfirm: {
    title: '确认删除',
    taskContent: '删除后不可恢复，确定删除任务「{name}-{number}」吗？',
  },
  tokenExpired: '登录已过期，请重新登录',
  pleaseLogin: '请登录后查看',
  logouting: '正在退出登录',
  saveSuccess: '保存成功',
  addSuccess: '添加成功',
  addFailed: '添加失败',
  addBtn: '添加',
  saveFailed: '保存失败',
  cancelSuccess: '取消成功',
  confirmDelete: '确认删除',
  operationFailed: '操作失败',
  operationSuccess: '操作成功',
  copySuccess: '复制成功',
  publishSuccess: '发布成功',
  publishFailed: '发布失败',
  mapDialog: {
    title: '地图定位',
    searchPlaceholder: '搜索地址',
    noAddressSelected: '未选择地址',
    confirmLocationTip: '请确认位置点，否则会影响求职者导航',
    addressUpdated: '地址已更新',
    searchAddressFirst: '请先在搜索框中输入地址',
  },
  addressSelector: {
    provincePlaceholder: '都道府县',
    detailPlaceholder: '详细地址: 包含区郡、市町村区、町丁、字、其他、建地等信息',
    mapLocation: '地图定位',
  },
  pleaseSelect: '请选择',
  pleaseEnter: '请输入',
  to: '至',
  startDate: '开始日期',
  endDate: '结束日期',
  total: '共计',
  items: '条',
  fetchFailed: '获取数据失败',
  loadFailed: '加载失败',
  requestTimeout: '请求超时，请稍后重试',
  networkError: '网络错误，请检查网络连接',
  deleteConfirmMessage: '删除后不可恢复，确定要删除吗？',
  warning: '警告',
  deleteFailed: '删除失败',
  imgUpload: {
    view: '查看',
    download: '下载',
    viewExample: '查看示例',
    downloadTemplate: '下载模板',
    fileFormatNotSupported: '文件格式不支持，请上传 {formats} 格式的文件',
    onlyImageAllowed: '只能上传图片文件',
    fileTooLarge: '文件大小不能超过 {size}',
    downloadSuccess: '下载成功',
    loadFailed: '图片加载失败',
  },
  imageUpload: {
    rotateTitle: '旋转图片',
    rotateLeft: '向左旋转',
    rotateRight: '向右旋转',
    rotateFailed: '图片旋转失败',
    uploadFailed: '上传失败',
    maxCountExceeded: '最多可上传 {count} 张图片',
  },
  no: '否',
  noData: '无数据',
  currency: {
    jpy: '日元',
  },
  units: {
    days: '天',
    hours: '小时',
    people: '人',
    years: '年',
    months: '个月',
    hoursPerMonth: '小时/月'
  },
  noAccessPermission: '无访问权限',
  noAccessGoList: '返回列表页',
  nextDay: '次日',
  curDay: '当日',
  noSetting: '未设置',
  authChange: '权限变更，请重新登录',
  searchNoData: '查询无结果',
  searchNoDataDetail: '可尝试修改查询条件',
  noSystemAccess: '抱歉，您没有访问系统的权限，请联系超级管理员或管理员',
  noCareerAccess: '无 Career 访问权限',
  contactAdminToEnable: '可联系管理员开通',
  enterTalentSystem: '进入 Talent 系统',
  noModuleAccess: '无模块访问权限',
  backToHome: '返回首页',
  add: '添加',
  emptyStates: {
    noConditions: {
      title: '暂无数据',
    },
    noResults: {
      title: '查询无结果',
      description: '可尝试修改查询条件'
    }
  },
  unopen: '未公开',
  parseSuccess: '解析成功',
  parseLoading: '解析中',
  parseFailed: '解析失败',
};
